import * as activityActionsConstants from '../../constants/actions/activityActions';
import * as authActionsConstants from '../../constants/actions/auth';
import * as organizationsActionsConstants from '../../constants/actions/organizationsActions'
import * as jobLocationService from '../../services/jobLocationService'

export function changeSelectedOrganization(organizationId) {
    return dispatch => {
        dispatch({type: activityActionsConstants.CHANGE_SELECTED_ORGANIZATION_HOME, payload: organizationId});
    };
}

export function changeUserPermission(changedPermission) {
    return dispatch => {
        dispatch({type: authActionsConstants.CHANGE_PERMISSION_STATUS, payload: changedPermission});
    };
}

export function getJobLocations(orgId){
    return dispatch => {
        dispatch({ type: organizationsActionsConstants.GET_JOB_LOCATIONS });
        
        jobLocationService.getJobLocationsList(orgId).then(response => {
            dispatch({
                type: organizationsActionsConstants.GET_JOB_LOCATIONS_SUCCESS,
                payload: response.data.payload
            });
        }).catch(() => {
            dispatch({type: organizationsActionsConstants.GET_JOB_LOCATIONS_ERROR});
        });
    }
}